import React from 'react';
import DEFAULT_ITEM from '../assets/defaults/menu-item-default.png';

const MenuItemImage = ({ src, alt, className, ...rest }) => {
    const handleError = (e) => {
        e.target.onerror = null;
        e.target.src = DEFAULT_ITEM;
    };

    return (
        <img
            src={src || DEFAULT_ITEM}
            alt={alt || "Menu Item Image"}
            className={className}
            onError={handleError}
            {...rest}
        />
    );
};

export default MenuItemImage;
